import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "executeasmodaloptions"
    }}>{`ExecuteAsModalOptions`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "commandname"
    }}>{`commandName`}</h3>
    <p>{`• `}<strong parentName="p">{`commandName`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`Name of the command, it will be used in the progress bar if the operation takes a noticeable amount of time`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      